import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function UnderReviewPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get("/messages/mine/under-review")
      .then(r => setItems(r?.data?.items || []))
      .finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <div className="max-w-[720px] mx-auto px-6 sm:px-10 py-16">
        <div className="oh-label mb-3">SIGN IN REQUIRED</div>
        <h1 className="text-3xl font-serif mb-4">Sign in to see your drafts under review.</h1>
        <Link to="/" className="oh-btn-primary" data-testid="review-signin-home">GO HOME</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[900px] mx-auto px-6 sm:px-10 py-16" data-testid="under-review-page">
      <div className="oh-label mb-3">MY DRAFTS · UNDER REVIEW</div>
      <h1 className="text-3xl sm:text-4xl font-serif mb-8">Waiting for a human reviewer.</h1>
      {loading && <div className="oh-label opacity-60">LOADING…</div>}
      {!loading && items.length === 0 && (
        <div className="oh-label opacity-60" data-testid="under-review-empty">
          You have no MESSAGEs under review right now.
        </div>
      )}
      <div className="space-y-4">
        {items.map((m) => (
          <div key={m.id} className="border oh-hairline p-5"
               data-testid={`under-review-item-${m.id}`}>
            <div className="oh-label mb-2">
              STATUS · UNDER REVIEW ·
              {" "}{new Date(m.created_at).toLocaleString()}
            </div>
            <div className="font-serif text-2xl mb-2">{m.title || "(untitled)"}</div>
            <p className="text-sm opacity-80 whitespace-pre-wrap">
              {(m.text || "").slice(0, 240)}{(m.text || "").length > 240 ? "…" : ""}
            </p>
            {m.review_reason && (
              <div className="oh-label mt-3 opacity-70">Reason · {m.review_reason}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
